import React from 'react';
import { Form, Select } from 'antd';
const { Option } = Select;

const StatusPayment = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Статус оплаты:">
      {getFieldDecorator('statusPayment')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите статус оплаты"
          allowClear={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          <Option key={1}>API не подключено</Option>
        </Select>
      )}
    </Form.Item>
  );
};

export default StatusPayment;
